import { render, staticRenderFns } from "./StartupsByProblemStatementChart.vue?vue&type=template&id=759d7002&"
import script from "./StartupsByProblemStatementChart.vue?vue&type=script&lang=js&"
export * from "./StartupsByProblemStatementChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports